import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-shopify-app',
  templateUrl: './shopify-app.component.html',
  styleUrls: ['./shopify-app.component.scss']
})
export class ShopifyAppComponent {


  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() selectedStoreApp: any;
  @Input() selectedProduct: any;
  @Input() connected: boolean = false;
  @Input() loadingBtn: boolean = false;
  @Input() loading: boolean = false;
  @Output() connect = new EventEmitter<void>();
  @Output() disconnect = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  storeName: string = '';
  isMobile = false;

  ngOnInit() {
    if(window.innerWidth <= 768){
      this.isMobile = true;
    }
    const localData = localStorage.getItem('store_data');
    if (localData) {
      try {
        const parsed = JSON.parse(localData);
        this.storeName = parsed?.store_name || 'Minha loja';
      } catch (e) {
        this.storeName = 'Minha loja';
      }
    }
  }

  removeMyshopify(domain: string | undefined): string {
    if (!domain) return '';
    return domain.replace('.myshopify.com', '');
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.close.emit();
  }
}
